Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.AppliedFilterSeeMoreButtonView extends Backbone.View
  tagName: 'span'
  className: 'see-more-button'

  events:
    'click': 'seeMore'

  render: ->
    @$el.text I18n.t('common.session.filters.multiple_values.see_more')
    @

  seeMore: ->
    @trigger 'seeMore'
